import { create } from "zustand";

// What a mention token and its hover card show of a member beyond the name the mention carries.
export interface MemberDisplay {
    imageUrl: string | undefined;
    jobTitle: string | undefined;
}

// The members the "@" list has found this session, by id. A mention carries only its member's id and name, so a mention
// rebuilt from markup (dictation, a restored reply, a paste) finds its photo and job title here.
interface MemberDisplayStore {
    memberDisplays: ReadonlyMap<string, MemberDisplay>;
    rememberMembers: (members: ReadonlyArray<{ id: string } & MemberDisplay>) => void;
}

export const useMemberDisplayStore = create<MemberDisplayStore>()(set => ({
    memberDisplays: new Map(),
    rememberMembers: members => set(state => {
        const isKnown = members.every(({ id, imageUrl, jobTitle }) => {
            const known = state.memberDisplays.get(id);

            return known !== undefined && known.imageUrl === imageUrl && known.jobTitle === jobTitle;
        });

        // Nothing new keeps the same Map, so the conversation reading it doesn't render again for each "@" search.
        return isKnown
            ? state
            : { memberDisplays: new Map([...state.memberDisplays, ...members.map(({ id, imageUrl, jobTitle }) => [id, { imageUrl, jobTitle }] as const)]) };
    })
}));
